import store from '../store/store'

const homeRouter = [
  {
    path: '',
    redirect: 'gwAdmin'
  },
  {
    path: 'gwAdmin',
    component: () => import('../views/home/children/gwAdmin'),
    children: [
      {
        path: '',
        redirect: 'gwList'
      },
      {
        path: 'gwList',
        component: () => import('../views/home/children/gwAdmin/gwList'),
        meta: {
          title: '顾问列表',
          needLogin: true // 是否需要登录才能访问
        }
      },
      {
        path: 'gwDetail/:id',
        component: () => import('../views/home/children/gwAdmin/gwDetail'),
        meta: {
          title: '顾问详情',
          needLogin: true // 是否需要登录才能访问
        }
      },
      {
        path: 'gwQianxian/:id',
        component: () => import('../views/home/children/gwAdmin/gwQianxian'),
        meta: {
          title: '权限管理',
          needLogin: true // 是否需要登录才能访问
        }
      },
      {
        path: 'gwAdd',
        component: () => import('../views/home/children/gwAdmin/gwAdd'),
        meta: {
          title: '创建顾问',
          needLogin: true // 是否需要登录才能访问
        }
      }, {
        path: 'gwRizhi',
        component: () => import('../views/home/children/gwAdmin/gwRizhi'),
        meta: {
          title: '查看日志',
          needLogin: true // 是否需要登录才能访问
        }
      }
    ],
  },
  {
    path: 'hxrAdmin',
    component: () => import('../views/home/children/hxrAdmin'),
    children: [
      {
        path: '',
        redirect: 'hxrList'
      },
      {
        path: 'hxrList',
        component: () => import('../views/home/children/hxrAdmin/hxrList'),
        meta: {
          title: '候选人列表',
          needLogin: true // 是否需要登录才能访问
        }
      },
      {
        path: 'hxrDetail/:id',
        component: () => import('../views/home/children/hxrAdmin/hxrDetail'),
        meta: {
          title: '候选人详情',
          needLogin: true // 是否需要登录才能访问
        }
      },
      {
        path: 'hxrResume',
        component: () => import('../views/home/children/hxrAdmin/hxrResume'),
        meta: {
          title: '候选人简历预览',
          needLogin: true // 是否需要登录才能访问
        }
      },
      {
        path: 'hxrEmail',
        component: () => import('../views/home/children/hxrAdmin/hxrEmail'),
        meta: {
          title: '候选人求职信预览',
          needLogin: true // 是否需要登录才能访问
        }
      },
      {
        path: 'hxrRizhi',
        component: () => import('../views/home/children/hxrAdmin/hxrRizhi'),
        meta: {
          title: '候选人日志',
          needLogin: true // 是否需要登录才能访问
        }
      },
      {
        path: 'hxrForm',
        component: () => import('../views/home/children/hxrAdmin/hxrForm'),
        meta: {
          title: '我的表单',
          needLogin: true // 是否需要登录才能访问
        }
      },
      {
        path: 'hxrBiaoDanDetail/:id',
        component: () => import('../views/home/children/hxrAdmin/hxrBiaoDanDetail'),
        meta: {
          title: '候选人表单详情',
          needLogin: true // 是否需要登录才能访问
        }
      },
      {
        path: 'hxrPaiming',
        component: () => import('../views/home/children/hxrAdmin/hxrPaiming'),
        meta: {
          title: '简历推荐排名',
          needLogin: true // 是否需要登录才能访问
        }
      },
      {
        path: 'hxrPaiming2',
        component: () => import('../views/home/children/hxrAdmin/hxrPaiming2'),
        meta: {
          title: '候选人推荐排名',
          needLogin: true // 是否需要登录才能访问
        }
      },
      {
        path: 'fabuShen',
        component: () => import('../views/home/children/hxrAdmin/fabuShen'),
        meta: {
          title: '简历发布审核',
          needLogin: true // 是否需要登录才能访问
        }
      },
      {
        path: 'qiuzhi',
        component: () => import('../views/home/children/hxrAdmin/qiuzhi'),
        meta: {
          title: '求职信发布审核',
          needLogin: true // 是否需要登录才能访问
        }
      },
      {
        path: 'xinxiShen',
        component: () => import('../views/home/children/hxrAdmin/xinxiShen'),
        meta: {
          title: '基础信息审核',
          needLogin: true // 是否需要登录才能访问
        }
      },
      {
        path: 'hxrJiBenDetail/:id',
        component: () => import('../views/home/children/hxrAdmin/hxrJiBenDetail'),
        meta: {
          title: '候选人基本信息详情',
          needLogin: true // 是否需要登录才能访问
        }
      },
      {
        path: 'hxrInvitation',
        component: () => import('../views/home/children/hxrAdmin/hxrInvitation'),
        meta: {
          title: '邀请注册',
          needLogin: true // 是否需要登录才能访问
        }
      },
      {
        path: 'addList',
        component: () => import('../views/home/children/hxrAdmin/addList'),
        meta: {
          title: '邀请统计',
          needLogin: true // 是否需要登录才能访问
        }
      },
      {
        path: 'hxraddList',
        component: () => import('../views/home/children/hxrAdmin/hxraddList'),
        meta: {
          title: '候选人邀请统计',
          needLogin: true // 是否需要登录才能访问
        }
      },
      {
        path: 'orgaddList',
        component: () => import('../views/home/children/hxrAdmin/orgaddList'),
        meta: {
          title: '机构邀请统计',
          needLogin: true // 是否需要登录才能访问
        }
      },
    ],
  },
  {
    path: 'jgAdmin',
    component: () => import('../views/home/children/jgAdmin'),
    children: [
      {
        path: '',
        redirect: 'jgList'
      },
      {
        path: 'jgList',
        component: () => import('../views/home/children/jgAdmin/jgList'),
        meta: {
          title: '机构列表',
          needLogin: true // 是否需要登录才能访问
        }
      },
      {
        path: 'jgShuangxuan',
        component: () => import('../views/home/children/jgAdmin/jgShuangxuan'),
        meta: {
          title: '双选会机构',
          needLogin: true // 是否需要登录才能访问
        }
      },
      {

        path: 'jgRizhi',
        component: () => import('../views/home/children/jgAdmin/jgRizhi'),
        meta: {
          title: '机构日志',
          needLogin: true // 是否需要登录才能访问
        }
      },
      {
        path: 'jgDetail/:id',
        component: () => import('../views/home/children/jgAdmin/jgDetail'),
        meta: {
          title: '机构详情',
          needLogin: true // 是否需要登录才能访问
        }
      },
      {
        path: 'jgDetailEdit/:id',
        component: () => import('../views/home/children/jgAdmin/jgDetailEdit'),
        meta: {
          title: '机构详情修改',
          needLogin: true // 是否需要登录才能访问
        }
      },
      {
        path: 'jgZhiw/:id',
        component: () => import('../views/home/children/jgAdmin/jgZhiw'),
        meta: {
          title: '机构职位详情',
          needLogin: true // 是否需要登录才能访问
        }
      },
      {
        path: 'jgForm',
        component: () => import('../views/home/children/jgAdmin/jgForm'),
        meta: {
          title: '我的表单',
          needLogin: true // 是否需要登录才能访问
        }
      },
      {
        path: 'jgBiaoDanDetail/:id',
        component: () => import('../views/home/children/jgAdmin/jgBiaoDanDetail'),
        meta: {
          title: '候选人表单详情',
          needLogin: true // 是否需要登录才能访问
        }
      },
      {
        path: 'jgPay',
        component: () => import('../views/home/children/jgAdmin/jgPay'),
        meta: {
          title: '对公转账管理',
          needLogin: true // 是否需要登录才能访问
        }
      },
      {
        path: 'jgFrozen',
        component: () => import('../views/home/children/jgAdmin/jgFrozen'),
        meta: {
          title: '冻结资金管理',
          needLogin: true // 是否需要登录才能访问
        }
      },


      {
        path: 'jgJiChuXinXiShen',
        component: () => import('../views/home/children/jgAdmin/jgJiChuXinXiShen'),
        meta: {
          title: '基础信息变更审核',
          needLogin: true // 是否需要登录才能访问
        }
      },
      {
        path: 'jgJiChuXinXi/:id',
        component: () => import('../views/home/children/jgAdmin/jgJiChuXinXi'),
        meta: {
          title: '机构基础信息详情审核',
          needLogin: true // 是否需要登录才能访问
        }
      },
      {
        path: 'jgAccountadd',
        component: () => import('../views/home/children/jgAdmin/jgAccountadd'),
        meta: {
          title: '创建机构帐号',
          needLogin: true // 是否需要登录才能访问
        }
      },
      {
        path: 'jgInvoice',
        component: () => import('../views/home/children/jgAdmin/jgInvoice'),
        meta: {
          title: '发票管理',
          needLogin: true // 是否需要登录才能访问
        }
      },
    ]
  },
  {
    path: 'zwAdmin',
    component: () => import('../views/home/children/zwAdmin'),
    children: [
      {
        path: '',
        redirect: 'zwList'
      },
      {
        path: 'zwList',
        component: () => import('../views/home/children/zwAdmin/zwList'),
        meta: {
          title: '职位列表',
          needLogin: true // 是否需要登录才能访问
        }
      },
      {
        path: 'jgZhiWeiFaBuShen',
        component: () => import('../views/home/children/zwAdmin/jgZhiWeiFaBuShen'),
        meta: {
          title: '职位发布审核',
          needLogin: true // 是否需要登录才能访问
        }
      },
      {
        path: 'zwDetail/:id',
        component: () => import('../views/home/children/zwAdmin/zwDetail'),
        meta: {
          title: '职位详情',
          needLogin: true // 是否需要登录才能访问
        }
      },
      {
        path: 'resume/:id',
        component: () => import('../views/home/children/zwAdmin/resume'),
        meta: {
          title: '简历详情',
          needLogin: true // 是否需要登录才能访问
        }
      },
      {
        path: 'resume2/:id',
        component: () => import('../views/home/children/zwAdmin/resume2'),
        meta: {
          title: '简历详情',
          needLogin: true // 是否需要登录才能访问
        }
      },
      {
        path: 'zwaddList/:id',
        component: () => import('../views/home/children/zwAdmin/zwaddList'),
        meta: {
          title: '职位推荐',
          needLogin: true // 是否需要登录才能访问
        }
      },
      {
        path: 'zwForm',
        component: () => import('../views/home/children/zwAdmin/zwForm'),
        meta: {
          title: '我的表单',
          needLogin: true // 是否需要登录才能访问
        }
      },
      {
        path: 'zwBiaoDanDetail/:id',
        component: () => import('../views/home/children/zwAdmin/zwBiaoDanDetail'),
        meta: {
          title: '职位表单详情',
          needLogin: true // 是否需要登录才能访问
        }
      },
      {
        path: 'jgZhiw/:id',
        component: () => import('../views/home/children/jgAdmin/jgZhiw'),
        meta: {
          title: '机构职位详情',
          needLogin: true // 是否需要登录才能访问
        }
      },
    ],
  },
  {
    path: 'rzAdmin',
    component: () => import('../views/home/children/rzAdmin'),
    children: [
      {
        path: '',
        redirect: 'rzList'
      },
      {
        path: 'rzList',
        component: () => import('../views/home/children/rzAdmin/rzList'),
        meta: {
          title: '我的日志',
          needLogin: true // 是否需要登录才能访问
        }
      },
      {
        path: 'zwDetail',
        component: () => import('../views/home/children/rzAdmin/rzDetail'),
        meta: {
          title: '日志详情',
          needLogin: true // 是否需要登录才能访问
        }
      }
    ],
  },
  {
    path: 'yjAdmin',
    component: () => import('../views/home/children/yjAdmin'),
    children: [
      {
        path: '',
        redirect: 'yjList'
      },
      {
        path: 'yjList',
        component: () => import('../views/home/children/yjAdmin/yjList'),
        meta: {
          title: '查看业绩',
          needLogin: true // 是否需要登录才能访问
        }
      }
    ],
  },
  {
    path: 'bannerAdmin',
    component: () => import('../views/home/children/bannerAdmin'),
    meta: {
      title: '广告管理',
      needLogin: true // 是否需要登录才能访问
    }
  },
  {
    path: 'znxAdmin',
    component: () => import('../views/home/children/znxAdmin'),
    children: [
      {
        path: '',
        redirect: () => {
          let admin_type = Number.parseInt(store.state.user.admin_type)
          if (admin_type === 1 || admin_type === 2) {
            return 'znxPost'
          } else {
            return 'znxGet'
          }
        }
      },
      {
        path: 'znxPost',
        component: () => import('../views/home/children/znxAdmin/znxPost'),
        meta: {
          title: '我发送的',
          needLogin: true // 是否需要登录才能访问
        }
      },
      //
      {
        path: 'znxDetail/:id',
        component: () => import('../views/home/children/znxAdmin/znxDetail'),
        meta: {
          title: '站内信详情',
          needLogin: true // 是否需要登录才能访问
        }
      },
      {
        path: 'znxGet',
        component: () => import('../views/home/children/znxAdmin/znxGet'),
        meta: {
          title: '通知',
          needLogin: true // 是否需要登录才能访问
        }
      },
      {
        path: 'znxDetail2/:id',
        component: () => import('../views/home/children/znxAdmin/znxDetail2'),
        meta: {
          title: '站内信详情',
          needLogin: true // 是否需要登录才能访问
        }
      },
      {
        path: 'znxDetail3/:id',
        component: () => import('../views/home/children/znxAdmin/znxDetail3'),
        meta: {
          title: '站内信详情',
          needLogin: true // 是否需要登录才能访问
        }
      },
      {
        path: 'znxDetail4/:id',
        component: () => import('../views/home/children/znxAdmin/znxDetail4'),
        meta: {
          title: '站内信详情',
          needLogin: true // 是否需要登录才能访问
        }
      },
      {
        path: 'znxAdd',
        component: () => import('../views/home/children/znxAdmin/znxAdd'),
        meta: {
          title: '编辑站内信',
          needLogin: true // 是否需要登录才能访问
        }
      },
      {
        path: 'znxServe',
        component: () => import('../views/home/children/znxAdmin/znxServe'),
        meta: {
          title: '客服咨询',
          needLogin: true // 是否需要登录才能访问
        }
      },
      {
        path: 'znxComplaint',
        component: () => import('../views/home/children/znxAdmin/znxComplaint'),
        meta: {
          title: '投诉处理',
          needLogin: true // 是否需要登录才能访问
        }
      }
    ],
  },
  {
    path: 'passAdmin',
    component: () => import('../views/home/children/passAdmin'),
    children: [
      {
        path: '',
        redirect: 'passSet'
      },
      {
        path: 'passSet',
        component: () => import('../views/home/children/passAdmin/passSet'),
        meta: {
          title: '修改密码',
          needLogin: true // 是否需要登录才能访问
        }
      }
    ],
  },
  {
    path: 'caiwuAdmin',
    component: () => import('../views/home/children/caiwuAdmin'),
    children: [
      {
        path: '',
        redirect: 'yewu1'
      },
      {
        path: 'yewu1',
        component: () => import('../views/home/children/caiwuAdmin/yewu1'),
        meta: {
          title: '咸豆冻结记录',
          needLogin: true // 是否需要登录才能访问
        }
      },
      {
        path: 'yewu2',
        component: () => import('../views/home/children/caiwuAdmin/yewu2'),
        meta: {
          title: '咸豆扣除记录',
          needLogin: true // 是否需要登录才能访问
        }
      },
      {
        path: 'yewu3',
        component: () => import('../views/home/children/caiwuAdmin/yewu3'),
        meta: {
          title: '佣金发放记录',
          needLogin: true // 是否需要登录才能访问
        }
      },
      {
        path: 'yewu4',
        component: () => import('../views/home/children/caiwuAdmin/yewu4'),
        meta: {
          title: '充值记录',
          needLogin: true // 是否需要登录才能访问
        }
      },
      {
        path: 'yewu5',
        component: () => import('../views/home/children/caiwuAdmin/yewu5'),
        meta: {
          title: '提现记录',
          needLogin: true // 是否需要登录才能访问
        }
      },
      {
        path: 'yewu6',
        component: () => import('../views/home/children/caiwuAdmin/yewu6'),
        meta: {
          title: '熟人推荐',
          needLogin: true // 是否需要登录才能访问
        }
      }
    ]
  },
  {
    path: 'newsAdmin',
    component: () => import('../views/home/children/newsAdmin'),

    children: [
      {
        path: '',
        redirect: 'newsList'
      },
      {
        path: 'newsList',
        component: () => import('../views/home/children/newsAdmin/newsList'),
        meta: {
          title: '新闻资讯',
          needLogin: true // 是否需要登录才能访问
        }
      },
      {
        path: 'newsEdit',
        component: () => import('../views/home/children/newsAdmin/newsEdit'),
        meta: {
          title: '新闻编辑',
          needLogin: true // 是否需要登录才能访问
        }
      },
      {
        path: 'knowledgeList',
        component: () => import('../views/home/children/newsAdmin/knowledgeList'),
        meta: {
          title: '知识列表',
          needLogin: true // 是否需要登录才能访问
        }
      },
      {
        path: 'knowledgeEdit',
        component: () => import('../views/home/children/newsAdmin/knowledgeEdit'),
        meta: {
          title: '知识编辑',
          needLogin: true // 是否需要登录才能访问
        }
      }
    ]
  },
  {
    path: 'tongjiAdmin',
    component: () => import('../views/home/children/tongjiAdmin'),

    children: [
      {
        path: '',
        redirect: 'tongjiList'
      },
      {
        path: 'tongjiList',
        component: () => import('../views/home/children/tongjiAdmin/tongjiList'),
        meta: {
          title: '网站访问量',
          needLogin: true // 是否需要登录才能访问
        }
      },
      {
        path: 'tongjiList2',
        component: () => import('../views/home/children/tongjiAdmin/tongjiList2'),
        meta: {
          title: '机构注册比例',
          needLogin: true // 是否需要登录才能访问
        }
      },
      {
        path: 'tongjiList3',
        component: () => import('../views/home/children/tongjiAdmin/tongjiList3'),
        meta: {
          title: '机构注册量',
          needLogin: true // 是否需要登录才能访问
        }
      },
      {
        path: 'tongjiList4',
        component: () => import('../views/home/children/tongjiAdmin/tongjiList4'),
        meta: {
          title: '简历投递统计',
          needLogin: true // 是否需要登录才能访问
        }
      }
    ]
  },
  {
    path: 'meetAdmin',
    component: () => import('../views/home/children/meetAdmin'),

    children: [
      {
        path: '',
        redirect: 'meetList'
      },
      {
        path: 'meetList',
        component: () => import('../views/home/children/meetAdmin/meetList'),
        meta: {
          title: '一般双选会列表',
          needLogin: true // 是否需要登录才能访问
        }
      },
      {
        path: 'meetList2',
        component: () => import('../views/home/children/meetAdmin/meetList2'),
        meta: {
          title: '实习双选会列表',
          needLogin: true // 是否需要登录才能访问
        }
      },
      {
        path: 'meetDetail',
        component: () => import('../views/home/children/meetAdmin/meetDetail'),
        meta: {
          title: '双选会详情',
          needLogin: true // 是否需要登录才能访问
        }
      },
      {
        path: 'meetDetail2',
        component: () => import('../views/home/children/meetAdmin/meetDetail2'),
        meta: {
          title: '双选会详情',
          needLogin: true // 是否需要登录才能访问
        }
      },
      {
        path: 'meetAdd',
        component: () => import('../views/home/children/meetAdmin/meetAdd'),
        meta: {
          title: '创建双选会',
          needLogin: true // 是否需要登录才能访问
        }
      },
      {
        path: 'meetAdd2',
        component: () => import('../views/home/children/meetAdmin/meetAdd2'),
        meta: {
          title: '创建双选会',
          needLogin: true // 是否需要登录才能访问
        }
      },
      {
        path: 'meetEdit',
        component: () => import('../views/home/children/meetAdmin/meetEdit'),
        meta: {
          title: '修改双选会',
          needLogin: true // 是否需要登录才能访问
        }
      },
      {
        path: 'meetEdit2',
        component: () => import('../views/home/children/meetAdmin/meetEdit2'),
        meta: {
          title: '修改双选会',
          needLogin: true // 是否需要登录才能访问
        }
      },
      {
        path: 'applyList',
        component: () => import('../views/home/children/meetAdmin/applyList'),
        meta: {
          title: '实习生申请表',
          needLogin: true // 是否需要登录才能访问
        }
      },
    ]
  },
  {
    path: 'qzAdmin',
    component: () => import('../views/home/children/qzAdmin'),
    children: [
      {
        path: '',
        redirect: 'qzList'
      },
      {
        path: 'qzList',
        component: () => import('../views/home/children/qzAdmin/qzList'),
        meta: {
          title: '求职人员列表',
          needLogin: true // 是否需要登录才能访问
        }
      },

      {
        path: 'qzAdd',
        component: () => import('../views/home/children/qzAdmin/qzAdd'),
        meta: {
          title: '求职人员编辑',
          needLogin: true // 是否需要登录才能访问
        }
      }, {
        path: 'tjZhiwei',
        component: () => import('../views/home/children/qzAdmin/tjZhiwei'),
        meta: {
          title: '已推荐职位列表',
          needLogin: true // 是否需要登录才能访问
        }
      }
    ],
  },
]
export default homeRouter